import Vue from "vue";
import Vuex from "vuex";

// Modules
import app from "./app";
import appConfig from "./app-config";
import verticalMenu from "./vertical-menu";
import psimConfig from "./psim-config";
import center from "./center";
import sector from "./sector";
import camera_type from "./camera_type";
import cm_master_account from "./camera_manager/master_account";
import cm_reseller from "./camera_manager/reseller";
import cm_camera from "./camera_manager/camera";
import master_tenant from "./master-tenant";
import tenant from "./tenant";
import incident from "./tenant/incident";
import log_incident from "./tenant/log-incident";
import type_alarm from "./type_alarm";
import unit from "./unit";
import grid from "./grid";
import subsystem_tree from "./subsystem_tree";
import layouts from "./layouts";
import bd_camera from "./bridge/camera";
import bd_bridge from "./bridge/bridge";
import bd_account from "./bridge/account";
import bd_master_account from "./bridge/master_account";
import bbva_request_tag from "./bbva/tag";
import user from "./user";
import profile from "./profile";
import router from "./router";
import permission from "./permission";
import logs from "./logs";
import country from "./country";
import region from "./region";
import vxg_camera from "./vxg_camera";
import stream_type from "./stream_type";
import securos_camera from "./securos_camera";
import preset from "./preset";
import button from "./buttons";
import type_button from "./button_type";
import camera_status from "./status_cameras";
import seproban from "./seproban";
import token_omnitag from "./tokens_omnitag";
import plate_list from "./plate_list";
import plate from "./plate";
import group from "./group";
import traffic from "./traffic";
import alarm from "./alarm";
import alarm_views from "./alarm_views";
import lpr_coincidences from "./lpr_matches";
import facial_recognition from "./facial_recognition";
import incident_list from "./incident_list";
import user_app from "./user_app";
import swift_account from "./swift_account";
import swift_gateway from "./swift_collector";
import swift_sensor from "./swift_sensor";
import plane from "./plane";
import token from "./token";
import command from "./command";
import recording_request from "./recording_request";
import alarm_comment from "./alarm_comment";
import action_plan from "./tenant/action_plan";
import user_cameras from "./user_cameras";
import timeline from "./timeline";
import person_list from "./person_list";
import workflow from "./workflow";
import schedule_task from "./schedule_task";
import frequency_schedule_task from "./frequency_schedule_task";
import access_devices from "./access_devices";
import shared_tenant from "./shared_tenant";
import video_watermarks from "./video_watermarks";
import group_cameras from "./group_cameras";
import group_shared_tenant from "./group_shared_tenant";
import sip from "./sip";
import iotcomms_master_account from "./iotcomms/master_account";
import type_device_interphone from "./iotcomms/type_device_interphone";
import device_interphone from "./iotcomms/device_interphone";
import alarm_level from "./alarm/alarm_level";
import recording_request_status from "./recording_request_status";
import breadcrumbNav from "./breadcrumb";
import i18n from "./i18n";
import pages from "./pages";
import external_token from "./external_token";
import external_user from "./external_user";
import intelexvision from "./intelexvision";
import video_wall from "./video_wall";
import video_tag from "./video_tag";
import auth_two_factor from "./auth_two_factor";
import intelexvision_alarm_type from "./intelexvision/alarm_type";
import analytic_record from "./intelexvision/analytic_record";
import vxg_master_account from "./vxg_camera/master_account";
import securos_master_account from "./securos_camera/master_account";
import locale_login from "./locale_login";
import luna_master_account from "./luna/master_account";
import luna_list from "./luna/list";
import luna_face from "./luna/face";
import sip_call from "./sip_call";
import alarm_purge from "./alarm/alarm_purge";
import schedule_alarm from "./schedule_alarm";
import dahua_dvr from "./dahua/dvr";
import dahua_camera from "./dahua/camera";
import density from "./density";
import density_devices from "./density_devices";
import detection_event from "./detection_event";
import omniview_reseller from "./omniview_reseller";
import time_zone from "./time_zone";
import camera_proxy from "./camera_proxy";
import cm_proxy from "./camera_proxy";
import image_modal from "./image_modal";
import municipality from "./municipality";
import commands from "./commands";
import luna_facestream from "./luna/facestream";
import generic_devices from "./generic_devices";
import axis_body_cam_overview from "./axis_body_cam/overview";
import axis_body_cam_devices from "./axis_body_cam/devices";
import axis_body_cam_system_controllers from "./axis_body_cam/system_controllers";
import axis_body_cam_users from "./axis_body_cam/users";
import axis_body_cam_recordings from "./axis_body_cam/recordings";
import microservice_logs from "./microservice_logs";
import log_messages from "./log_messages";
import vehicle_brand from "./vehicle_brand";
import vehicle_model from "./vehicle_model";
import token_refresh from "./token_refresh";
import chatbot from "./chatbot";
import chatbotFake from "./chatbotFake";
import pacom_master_accounts from "./pacom/masterAccouts";
import pacom_sites from "./pacom/sites";
import pacom_schema_actions from "./pacom/schema_actions";
import pacom_schema_types from "./pacom/schemaTypes";
import pacom_devices from "./pacom/devices";
import pacom_actions from "./pacom/actions";
import pacom_alarm_types from "./pacom/alarmTypes";
import pacom_alarms from "./pacom/alarms";
import pacom_logs from "./pacom/logs";
import intelbras_panels from "./intelbras/intelbras_panels";
import intelbras_rules from "./intelbras/intelbras_rules";
import intelbras_events from "./intelbras/intelbras_events";
import intelbras_alarms from "./intelbras/intelbras_alarms";
import intelbras_logs from "./intelbras/intelbras_logs";
import intelbras_profiles from "./intelbras/intelbras_profiles";
import intelbras_alarm_panels from "./intelbras/intelbras_alarm_panels";
import alarm_panels from "./pacom/alarmPanels";
import chat from "./chat/group";
import tenants_storage from "./tenant/tenants_storage";
import tenant_files from "./tenant/files";
import helpdesk_group from "./helpdesk/group";
import helpdesk_ticket from "./helpdesk/ticket";
import helpdesk_ticket_types from "./helpdesk/ticket_types";
import helpdesk from "./help_desk/index";
import proxy_rtsp_server from "./generic_devices/proxy_rtsp_server";
import pbx_master_account from "./pbx/master_account";
import pbx_device from "./pbx/devices";
import action_plan_document from "./tenant/action_plan_document";
import sip_device from "./sip/devices";
import pbx_calls from "./pbx/calls";
import hanwha_dvr from "./hanwha/dvr";
import hanwha_camera from "./hanwha/camera";
import hanwha_alarm_profiles from "./hanwha/alarm_profiles";
import hanwha_alarm_rules from "./hanwha/alarm_rules";
import app_modules from "./app_modules";
import security_self_audits from "./security_self_audits";
import comments from "./comments";
import risk_evaluation from "./risk_evaluation";
import bau_complements from "./bau_complements";
import dmp_panels from "./dmp/dmp_panels";
import dmp_profiles from "./dmp/dmp_profiles";
import dmp_rules from "./dmp/dmp_rules";
import dmp_events_definition from "./dmp/dmp_events_definition";
import dmp_alarms from "./dmp/dmp_alarms";
import dmp_logs from "./dmp/dmp_logs";
import dmp_servers from "./dmp/dmp_servers";
import hikvision_master_account from "./hikvision/master_account";
import hikvision_dvr from "./hikvision/dvr";
import hikvision_camera from "./hikvision/camera";
import streams_vxg from "./streams_vxg";
import ms_detection_event from "./ms_detection_event";
import ntechlab_master_account from "./ntechlab/master_account";
import ntechlab_watch_list from "./ntechlab/watch_list";
import ntechlab_face from "./ntechlab/face";
import ntechlab_camera from "./ntechlab/camera";
import alarm_action from "./alarm_rules/action";
import alarm_filter_types from "./alarm_rules/filter_types";
import alarm_rules from "./alarm_rules/rule";
import alarm_types from "./alarm_rules/alarm_type";
import alarm_cameras from "./alarm_rules/alarm_cameras";
import institutions_tenant from "./institutions_tenant";
import facility_category from "./facility_category";
import unit_deactivation_catalog from "./unit_deactivation_catalog";
import companies from "./companies";
import employees from "./employees";
import alarm_groups from "./alarm_groups";
import send_to_seproban from "./seproban/send_to_seproban";
import bosch_panels from "./bosch/bosch_panels";
import bosch_logs from "./bosch/bosch_logs";
import bosch_profiles from "./bosch/bosch_profiles";
import bosch_rules from "./bosch/bosch_rules";
import seproban_events from "./seproban/seproban_events";
import seproban_images from "./seproban/seproban_images";
import bosch_events_definition from "./bosch/bosch_events_definition";
import omnicloud_watch_list from "./omnicloud_fr/watch_list";
import omnicloud_face from "./omnicloud_fr/face";
import omnicloud_camera from "./omnicloud_fr/camera";
import operational_security from "./operational_security";
import maintenance from "./maintenance";
import service_orders from "./service_orders";
import service_orders_status from "./service_orders_status";
import maintenance_template from "./maintenance_template";
import maintenance_crew from "./maintenance_crew"
import ai_analytics_servers from "./ai_analytics_servers";
import taken_alarms from "./alarm/taken_alarms";
import distribution_list from "./distribution-list/distribution_list";
import dmp_templates from "./dmp/dmp_templates";
import teams from "./teams";
import directory from "./directory";
import planning from "./planning";
import policyException from "./policyException";
import pisos from "./pisos";
import brigades from "./brigades";
import patrol_logs from "./patrol_logs";
import holliday from "./holliday"
import inventory_brands_catalog from "./inventory_brands_catalog";
import inventory_equipment_types_catalog from "./inventory_equipment_types_catalog";
import inventory_projects_catalog from "./inventory_projects_catalog";
import billing_holiday from "./billing_holiday";
import billing_price from "./billing_price";
import billing_finance from "./billing_finance";
import billing_provider from "./billing_provider";
import user_assigned_region from "./user_assigned_region";
import external_personnel_access_control_activities from "./external_personnel_access_control_activities";
import external_personnel_access_control from "./external_personnel_access_control";
import totem_logs from "./totem_logs";
import user_assigned_video_tour from "./user_assigned_video_tour";
import user_rh from "./user_rh";
import user_group_selection_option from "./user_group_selection_option";
import storage_provider from "./storage_provider";
import tenant_storage_provider from "./tenant/tenant_storage_provider";
import victronenergy_master_account from "./victronenergy/master_account";
import victronenergy_sites from "./victronenergy/sites";
import victronenergy_devices from "./victronenergy/devices";
import type_alarm_category from "./type_alarm_category";
import composite_alarm_rules from "./composite_alarm_rules/composite_rules"

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    psimConfig,
    center,
    sector,
    camera_type,
    cm_master_account,
    cm_reseller,
    cm_camera,
    master_tenant,
    tenant,
    unit,
    grid,
    subsystem_tree,
    layouts,
    bd_camera,
    bd_bridge,
    bd_account,
    bd_master_account,
    type_alarm,
    incident,
    log_incident,
    bbva_request_tag,
    user,
    country,
    region,
    profile,
    router,
    permission,
    vxg_camera,
    stream_type,
    securos_camera,
    preset,
    button,
    type_button,
    camera_status,
    seproban,
    token_omnitag,
    logs,
    plate_list,
    plate,
    lpr_coincidences,
    traffic,
    alarm,
    alarm_views,
    group,
    facial_recognition,
    incident_list,
    user_app,
    swift_account,
    swift_gateway,
    swift_sensor,
    token,
    plane,
    command,
    recording_request,
    alarm_comment,
    action_plan,
    user_cameras,
    timeline,
    person_list,
    workflow,
    schedule_task,
    frequency_schedule_task,
    shared_tenant,
    video_watermarks,
    group_cameras,
    access_devices,
    iotcomms_master_account,
    type_device_interphone,
    device_interphone,
    alarm_level,
    sip,
    recording_request_status,
    breadcrumbNav,
    i18n,
    pages,
    external_token,
    external_user,
    intelexvision,
    video_tag,
    video_wall,
    auth_two_factor,
    intelexvision_alarm_type,
    analytic_record,
    vxg_master_account,
    securos_master_account,
    locale_login,
    luna_master_account,
    luna_list,
    luna_face,
    sip_call,
    alarm_purge,
    group_shared_tenant,
    schedule_alarm,
    dahua_dvr,
    dahua_camera,
    density_devices,
    density,
    detection_event,
    ms_detection_event,
    omniview_reseller,
    time_zone,
    camera_proxy,
    cm_proxy,
    image_modal,
    municipality,
    generic_devices,
    axis_body_cam_overview,
    axis_body_cam_devices,
    axis_body_cam_system_controllers,
    axis_body_cam_users,
    axis_body_cam_recordings,
    ...commands,
    vehicle_brand,
    luna_facestream,
    microservice_logs,
    log_messages,
    vehicle_model,
    token_refresh,
    chatbot,
    chatbotFake,
    pacom_master_accounts,
    pacom_sites,
    pacom_schema_actions,
    pacom_schema_types,
    pacom_devices,
    pacom_actions,
    pacom_alarm_types,
    pacom_alarms,
    pacom_logs,
    intelbras_panels,
    intelbras_rules,
    intelbras_events,
    intelbras_alarms,
    intelbras_logs,
    intelbras_profiles,
    intelbras_alarm_panels,
    alarm_panels,
    chat,
    tenants_storage,
    tenant_files,
    helpdesk_group,
    helpdesk_ticket,
    helpdesk_ticket_types,
    helpdesk,
    proxy_rtsp_server,
    pbx_master_account,
    pbx_device,
    action_plan_document,
    sip_device,
    pbx_calls,
    hanwha_dvr,
    hanwha_camera,
    hanwha_alarm_profiles,
    hanwha_alarm_rules,
    app_modules,
    security_self_audits,
    comments,
    risk_evaluation,
    bau_complements,
    dmp_panels,
    dmp_profiles,
    dmp_rules,
    dmp_events_definition,
    dmp_alarms,
    dmp_logs,
    dmp_servers,
    dmp_templates,
    hikvision_master_account,
    hikvision_dvr,
    hikvision_camera,
    ntechlab_master_account,
    ntechlab_watch_list,
    ntechlab_face,
    ntechlab_camera,
    alarm_rules,
    alarm_filter_types,
    alarm_action,
    alarm_types,
    alarm_cameras,
    institutions_tenant,
    facility_category,
    unit_deactivation_catalog,
    streams_vxg,
    companies,
    employees,
    alarm_groups,
    send_to_seproban,
    bosch_panels,
    bosch_logs,
    bosch_profiles,
    bosch_rules,
    seproban_events,
    seproban_images,
    bosch_events_definition,
    omnicloud_watch_list,
    omnicloud_face,
    omnicloud_camera,
    operational_security,
    maintenance,
    service_orders,
    service_orders_status,
    maintenance_template,
    maintenance_crew,
    ai_analytics_servers,
    taken_alarms,
    distribution_list,
    teams,
    directory,
    planning,
    policyException,
    pisos,
    brigades,
    ...patrol_logs,
    holliday,
    inventory_brands_catalog,
    inventory_equipment_types_catalog,
    inventory_projects_catalog,
    billing_holiday,
    billing_price,
    billing_finance,
    billing_provider,
    user_assigned_region,
    external_personnel_access_control_activities,
    external_personnel_access_control,
    user_rh,
    totem_logs,
    user_assigned_video_tour,
    user_group_selection_option,
    storage_provider,
    tenant_storage_provider,
    victronenergy_master_account,
    victronenergy_sites,
    victronenergy_devices,
    type_alarm_category,
    composite_alarm_rules,
  },
  strict: window.__env.DEV,
});
